"use client";
import { b as a, c as u } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { a as i } from "./detectBrowser-CpuomNQW.mjs";
const s = "data-base-ui-focusable", m = "active", E = "selected", c = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", R = "ArrowLeft", A = "ArrowRight", h = "ArrowUp", T = "ArrowDown";
function d(t) {
  var o;
  let e = t.activeElement;
  for (; ((o = e == null ? void 0 : e.shadowRoot) == null ? void 0 : o.activeElement) != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
function p(t, e) {
  var r;
  if (!t || !e)
    return !1;
  const o = (r = e.getRootNode) == null ? void 0 : r.call(e);
  if (t.contains(e))
    return !0;
  if (o && a(o)) {
    let n = e;
    for (; n; ) {
      if (t === n)
        return !0;
      n = n.parentNode || n.host;
    }
  }
  return !1;
}
function w(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function g(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const o = t;
  return o.target != null && e.contains(o.target);
}
function _(t) {
  return t.matches("html,body");
}
function O(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
function f(t) {
  return u(t) && t.matches(c);
}
function L(t) {
  return t ? t.getAttribute("role") === "combobox" && f(t) : !1;
}
function S(t) {
  if (!t || i)
    return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function y(t) {
  return t ? t.hasAttribute(s) ? t : t.querySelector(`[${s}]`) || t : null;
}
export {
  h as A,
  s as F,
  E as S,
  T as a,
  R as b,
  p as c,
  A as d,
  d as e,
  O as f,
  w as g,
  y as h,
  L as i,
  _ as j,
  g as k,
  m as l,
  f as m,
  S as n
};
